export default "__VITE_ASSET__29ede6ce__"